import { addMonths } from 'utils/date/date';

class Installment {
  amount: number;
  interval: number;
  startDate: Date | number;
  subunitToUnit: number;
  unitsToRound: number;
  type: string;

  constructor({
    amount = 0,
    interval = 1,
    startDate = Date.now(),
    subunitToUnit = 100,
    unitsToRound = 1,
    type = 'fixed',
  }: {
    amount?: number;
    interval?: number;
    startDate?: Date | number;
    subunitToUnit?: number;
    unitsToRound?: number;
    type?: string;
  }) {
    this.amount = amount;
    this.interval = interval;
    this.startDate = startDate;
    this.subunitToUnit = subunitToUnit;
    this.unitsToRound = unitsToRound;
    this.type = type;
  }

  get fee() {
    const fee = this.amount / this.interval;
    const roundedSubunits = this.unitsToRound * this.subunitToUnit;

    return Math.ceil(fee / roundedSubunits) * roundedSubunits;
  }

  get dates() {
    return [...new Array(this.interval).keys()].map(num => {
      return addMonths(this.startDate, num);
    });
  }

  get starts() {
    return this.dates[0];
  }

  get ends() {
    return this.dates.slice(-1)[0];
  }
}

export { Installment };
